import axios from "axios";

const getInmuebles = async (data) => {
  try {
    let response = await axios.post("https://wsrfa.sannicolasciudad.gob.ar/cobrojud/recImpInm.php", {
      data: {
        bsq: 1,
        ...data
      }
    });

    let result = response?.data;

    return result;
  }
  catch (err) {
    return err.message;
  }
};

// const getInmueble = (id) => {
//   console.log("id", id);
//   const inmueble = arrayData.find((e) => +e.id === +id);

//   return inmueble;
// };

// const editInmueble = (newData) => {
//   let result = arrayData.map((e) => { return (e.key === newData.key) ? newData : e; });

//   return result;
// };

// const deleteInmueble = (data) => {
//   let result = arrayData.filter((e) => e.key !== data.key);

//   return result;
// };


export const inmuebleService = {
  getInmuebles,
};
